export const validateRegex = {
  password:
    /^(?=.*[0-9])(?=.*[-!@#$%^>()[\]?<:;|'"&/*+}{=.,_\\])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9-!@#$%^>()[\]?<:;|'"&/*+}{=.,_\\]{8,}$/g,
  membershipNo: /^([0-9]{0,})$/g,
  onlyNumber: /^([0-9]{0,})$/g,
  contactNo: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/g,
  pin: /^([0-9]{6,})$/g,
};
